module.exports = __webpack_public_path__ + "img/1-4.d2453ae1.svg";